import { APP_ROUTES } from '@/navigators/routes';
import {
  ParamListBase,
  TabActions,
  TabNavigationState,
  useNavigation,
} from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';
import { useNavigationConfirmationContext } from '@/contexts/navigation-confirmation-context';

export type NavigationStateType = TabNavigationState<ParamListBase>;

export interface RouteMapType {
  index: number;
  route: NavigationStateType['routes'][0];
}

export type ActiveNavEntry =
  | { index: number; type: 'route' }
  | { productId: string; type: 'product' }
  | { type: 'more' };

export const useSideNavPress = () => {
  const { navigationBlocked } = useNavigationConfirmationContext();
  const navigation = useNavigation<StackNavigationProp<ParamListBase>>();

  return useCallback(
    (
      routeName: APP_ROUTES,
      isFocused?: boolean,
      params?: Record<string, unknown>,
    ) => {
      if (navigationBlocked) {
        return;
      }
      if (isFocused) {
        try {
          navigation.popToTop?.();
        } catch (error) {}
      } else {
        navigation.dispatch(TabActions.jumpTo(routeName, params));
      }
    },
    [navigation, navigationBlocked],
  );
};
